import React, { useId } from "react";

import styles from "./business-impact.module.scss";

type Props = {
  label: string;
  month: number;
  of: number;
  // "Month 6 / 12", in the viewer's language.
  valueText: string;
  note: string;
};

const ProgressBlock = ({ label, month, of, valueText, note }: Props) => {
  const id = useId();
  return (
    <div className={styles["progress"]}>
      <div className={styles["progress-head"]}>
        <span id={id}>{label}</span>
        <span>{valueText}</span>
      </div>
      <div
        role="progressbar"
        aria-labelledby={id}
        aria-valuemin={0}
        aria-valuemax={of}
        aria-valuenow={month}
        aria-valuetext={valueText}
        className={styles["progress-bar"]}
      >
        <span style={{ width: `${(month / of) * 100}%` }} />
      </div>
      <p className={styles["progress-note"]}>{note}</p>
    </div>
  );
};

export default ProgressBlock;
